<template>
  <div class="ksm-flex-column" id="ksm-app" lang="de">
    <header-view class="ksm-flex-00auto"></header-view>
    <keep-alive
      :include="[
        'orteundwege',
        'modusstart',
        'medienOverview',
        'personen',
        'suche',
      ]"
    >
      <router-view class="ksm-flex-1" style="margin-bottom: 10px"></router-view>
    </keep-alive>
    <footer-view class="ksm-flex-00auto"></footer-view>
    <modal name="ieModal">
      <div style="padding: 10px; height: 100%" class="ksm-flex-column">
        <div
          style="text-align: center; margin: 10px; font-size: 18pt"
          class="ksm-flex-1"
        >
          Ihr Browser wird nicht unterstützt
        </div>
        <div>
          Diese Webseite verwendet moderne Webtechnologien die von aktuellen
          Browsern unterstützt werden. Mit Internet Explorer kann es zu
          Verzeichnungen und Überlagerungen kommen.
        </div>
        <div>
          Bitte verwenden Sie anstatt dessen einen der folgenden Browser:
        </div>
        <ul style="padding: 10px 20px">
          <li>
            <a
              href="https://www.google.com/intl/de/chrome/"
              target="_blank"
              rel="noopener"
              >Google Chrome</a
            >
          </li>
          <li>
            <a
              href="https://www.mozilla.org/de-de/firefox/new/"
              target="_blank"
              rel="noopener"
              >Firefox</a
            >
          </li>
          <li>
            <a
              href="https://www.apple.com/safari/"
              target="_blank"
              rel="noopener"
              >Safari</a
            >
          </li>
          <li>
            <a
              href="https://www.microsoft.com/windows/microsoft-edge"
              target="_blank"
              rel="noopener"
              >Microsoft Edge</a
            >
          </li>
        </ul>
        <div class="ksm-flex-00auto" style="text-align: center">
          <div
            style="
              padding: 5px 20px;
              background-color: grey;
              color: #fff;
              display: inline-block;
              border-radius: 2px;
            "
            @click="$modal.hide('ieModal')"
          >
            Schließen
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Header from "./views/Head.vue";

import Footer from "./views/Footer.vue";

export default {
  components: {
    "header-view": Header,
    "footer-view": Footer,
  },
  mounted: function () {
    this.$store.dispatch("fetchMerzAndPersonData");
    this.$store.dispatch("fetchBibliographie");
    const ieVer = this.detectIE();
    if (ieVer && ieVer < 12) {
      this.$modal.show("ieModal");
    }
  },
  methods: {
    detectIE() {
      const ua = window.navigator.userAgent;

      const msie = ua.indexOf("MSIE ");
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
      }

      const trident = ua.indexOf("Trident/");
      if (trident > 0) {
        // IE 11 => return version number
        const rv = ua.indexOf("rv:");
        return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
      }

      const edge = ua.indexOf("Edge/");
      if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
      }

      // other browser
      return false;
    },
  },
};
</script>

<style lang="scss">
body {
  position: absolute;
  height: 100%;
  width: 100%;
  margin: 0px;
  padding: 0px;
  div {
    box-sizing: border-box !important;
  }
  a {
    text-decoration-line: none;
    @extend .g-select-disable;
  }

  font-size: 11pt;
  background-image: url("../static/icons/background_kachel.jpg");
  background-repeat: repeat;
}

#ksm-app {
  @extend .ksm-control-font;
  height: 100%;
  width: 100%;
  position: relative;
  min-width: 1000px;
  min-height: 500px;
}
</style>


// WEBPACK FOOTER //
// App.vue?23a9376f